import React from 'react';
import MuiFormLabel from '@mui/material/FormLabel';
import { Box } from '@mui/material';

import styles from './label.style';

export const Label = ({ children, isRequired = false }) => {
  return (
    <MuiFormLabel sx={styles.label}>
      {children}
      {isRequired && <Box sx={styles.asterik}>*</Box>}
    </MuiFormLabel>
  );
};
export default Label;
